export const titles: {
  path: string;
  param: string;
  setTitle: (key?: string | number) => string;
}[] = [
  {
    path: '/',
    param: '',
    setTitle: () => 'Trang Chủ',
  },
  {
    path: '/sign-in',
    param: '',
    setTitle: () => 'Đăng nhập',
  },
  {
    path: '/role-based-auth',
    param: '',
    setTitle: () => 'Phân quyền nhân viên',
  },
  {
    path: '/groups',
    param: '',
    setTitle: () => 'Danh sách nhóm',
  },
  {
    path: '/functions',
    param: '',
    setTitle: () => 'Danh sách quyền',
  },
  {
    path: '/job-title',
    param: '',
    setTitle: () => 'Quản lý mã chức vụ',
  },
  {
    path: '/mapping-job-title',
    param: '',
    setTitle: () => 'Quản lý tự động gán nhóm',
  },
  {
    path: '/profile',
    param: '',
    setTitle: () => 'Hồ sơ cá nhân',
  },
  {
    path: '/department-approval',
    param: '',
    setTitle: () => 'Phê duyệt',
  },
  {
    path: '/brand',
    param: '',
    setTitle: () => 'Nhãn hàng',
  },
  {
    path: '/brand/add-brand',
    param: '',
    setTitle: () => 'Thêm nhãn hàng',
  },
  {
    path: '/brand/edit',
    param: '',
    setTitle: () => 'Chỉnh sửa nhãn hàng',
  },
  {
    path: '/brand/details',
    param: '',
    setTitle: () => 'Thông tin nhãn hàng',
  },
  {
    path: '/branch-cabinet',
    param: '',
    setTitle: () => 'Chi nhánh',
  },
  {
    path: '/category',
    param: '',
    setTitle: () => 'Danh mục hàng hóa',
  },
  {
    path: '/recommended-list',
    param: '',
    setTitle: () => 'Danh mục khuyến nghị',
  },
  {
    path: '*',
    param: '',
    setTitle: () => 'Trang không tồn tại',
  },
];

export const PageTitle = 'PNJ - PMS';
